define("conversations/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _routes.default)(function () {
    this.route('upgrade');
    this.route('profile', {
      path: '/:social_profile_slug'
    }, function () {
      this.route('inbox', function () {
        this.route('post', {
          path: '/:post_id'
        });
      });
      this.route('posts', function () {
        this.route('post', {
          path: '/:post_id'
        });
      });
      this.route('users', function () {
        this.route('user', {
          path: '/:username'
        });
      });
    });
  });

  _exports.default = _default;
});